<div class="klab-login-page">
  <div class="login-page__overlay">
    <ui-sec-login [errors]="loginErrors" [alert]="alert" [loading]="isSubmitLoading" (formSubmit)="onSubmit($event.value)"
      (clearServerErrors)="onClearLoginErrors()">
    </ui-sec-login>
  </div>
</div>
